/* eslint-disable max-lines */
import React, { useContext, useEffect, useState } from 'react';
import { TimeSelect, CalendarInput } from '../UI';
import ClinicInput from '../UI/inputs/ClinicInput';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import ClinicAutocomplete from '../UI/inputs/ClinicAutocomplete';
import SearchableSelect from '../UI/inputs/SearchableSelect';
import moment from 'moment-jalaali';
import { makeStyles, Grid, Button } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import {
    putPatientReport,
    postPatientReport,
    getAReportAllLocation,
    selectTheReport
} from '../../redux/Reports/ReportsAction';
import { TextEditor } from '../UI';
import { ButtonCircularProgress } from '../UI/Buttons/SubmitButton';
import { PropTypes } from 'prop-types';
import Picture from './Picture/Picture';
import MessagesContext from '../../contexts/messagesContext';
import useCheckMobileScreen from '../../hooks/useWidth';
import { useHistory, useParams } from 'react-router';
import WithPatientFileHeader from '../PatientFileHeader/WithPatientFileHeader';

const styles = makeStyles((theme) => ({
    grid__item__text__editor: {
        padding: '10px !important'
    },
    grid__item__buttons: {
        padding: '45px 0px 0px 10px !important'
    },
    TextEditor: {
        textAlign: 'right',
        // margin: '0px auto',
        marginTop: '20px',
        marginBottom: '20px',
        maxHeight: '50vh'
    },
    formContainer: {
        position: 'relative',
        // padding: '30px 55px',
        overflowX: 'hidden',
        [theme.breakpoints.down(1025)]: {
            background: '#f5f6fa'
        }
    },

    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    submitButtons: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '35%',
        marginRight: 'auto',
        '& > div': {
            width: '48%'
        },
        [theme.breakpoints.down(1025)]: {
            width: '100%',
            '& > div': {
                width: '49%'
            }
        }
    },
    deleteButton: {
        direction: 'ltr',
        marginRight: '10px'
    },

    button: {
        width: '140px',
        height: '45px',
        borderRadius: '100px !important',
        backgroundColor: '#1b90fa',
        alignSelf: 'flex-end',
        whiteSpace: 'no-wrap'
    },
    cancelBtn: {
        margin: '0 15px',
        width: '85px',
        height: '45px',
        borderRadius: '100px !important',
        color: theme.palette.error.main,
        border: '2px solid #ef1734',
        background: 'white'
    }
}));

const mobileStyles = makeStyles({
    col1: {
        padding: '24px 24px 97px 24px',
        background: '#fff'
    },
    col2: {
        padding: '0 24px 24px 24px !important',
        background: '#fff'
    }
});

const RadiologyForm = ({ handleClose, onSubmit }) => {
    const isMobile = useCheckMobileScreen();
    const params = useParams();
    const history = useHistory();
    const { messages } = useContext(MessagesContext);
    const classes = styles();
    const mobileClasses = mobileStyles();
    const dispatch = useDispatch();
    const patientId = useSelector((state) => state.patient?.patient?.profile?.id);
    const path = `/${params.clinicId}/patient/${params.id}/radiology`;
    const {
        allTypes,
        allLocations,
        provider,
        requester,
        locations,
        type,
        content,
        images,
        reportId,
        reported
    } = useSelector((state) => state?.reports?.form);

    const imageFiles = images;
    const [locationsSpinner, setLocationsSpinner] = useState(false);
    useEffect(() => {
        if (reportId) {
            const getLocations = async () => {
                setLocationsSpinner(true);
                await dispatch(getAReportAllLocation(type.id));
                setLocationsSpinner(false);
            };
            getLocations();
        }
    }, []);
    const findLocations = async (typeId, newAllLocationsAndType) => {
        const typeElement = allTypes.find((type) => type.id === typeId);
        const getLocations = () => {
            return new Promise((resolve) => {
                const response = dispatch(getAReportAllLocation(typeId, typeElement));
                resolve(response);
            });
        };
        const response = await getLocations();
        if (response?.status === 200) {
            newAllLocationsAndType(response.data.report_locations);
        } else {
            findLocations(typeId, newAllLocationsAndType);
        }
    };
    const formHandler = async (values, actions) => {
        actions.setSubmitting(true);
        const time =
            values.time !== '00:00'
                ? moment(values.reported + ' ' + values.time)
                      .tz('Asia/Tehran')
                      .format()
                : moment(values.reported).tz('Asia/Tehran').format();
        const reportFormFunction = () => {
            let response;
            return new Promise((resolve) => {
                if (reportId) {
                    response = dispatch(putPatientReport(reportId, values, time));
                } else {
                    response = dispatch(postPatientReport(patientId, values, time));
                }
                resolve(response);
            });
        };
        const { status, data } = await reportFormFunction();

        if (status === 200) {
            //actions.resetForm({});
            //actions.setStatus({ success: true });
            actions.setSubmitting(false);
            dispatch(selectTheReport(data));
            if (isMobile) {
                history.replace(path);
            } else {
                handleClose();
            }
        } else {
            actions.setStatus({ success: false });
            actions.setSubmitting(false);
        }
    };
    const handleCancel = (resetForm) => {
        if (isMobile) {
            resetForm();
        } else {
            handleClose();
            dispatch({ type: 'CANCEL_CHANGE' });
        }
    };

    return (
        <Formik
            enableReinitialize
            initialValues={{
                requester,
                provider,
                reported: reported
                    ? moment(reported).format('YYYY-MM-DD')
                    : moment().format('YYYY-MM-DD'),
                locations,
                time: reported
                    ? moment(reported).format('HH:MM') !== '00:00'
                        ? moment(reported).format('HH:mm')
                        : ''
                    : '',
                type: type || '',
                content,
                images: [],
                allLocationsForm: allLocations
            }}
            validationSchema={Yup.object({
                type: Yup.string().min(2, messages.validations.required),
                locations: Yup.array().min(1, messages.validations.required)
            })}
            onSubmit={(values, actions) => {
                formHandler(values, actions);
                onSubmit(values);
            }}
        >
            {({ errors, touched, values, setFieldValue, isSubmitting, resetForm }) => {
                return (
                    <>
                        <Form className={classes.formContainer}>
                            <Grid
                                container
                                spacing={2}
                                direction={!isMobile && 'row'}
                                alignItems={'baseline'}
                                className={isMobile && mobileClasses.col1}
                            >
                                <Grid item xs={12} md={6}>
                                    <SearchableSelect
                                        width="100%"
                                        optionsDirection="ltr"
                                        optionalToUse
                                        options={allTypes}
                                        optionsLabel="name"
                                        label={messages.modality}
                                        name="type"
                                        value={values.type?.id}
                                        data-testid="takePhoto"
                                        setValue={(value) => {
                                            if (!value) {
                                                setFieldValue('allLocationsForm', []);
                                            } else {
                                                setFieldValue('locations', []);
                                                setFieldValue(
                                                    'type',
                                                    allTypes.find((type) => type.id === value),
                                                    false
                                                );
                                                if (value !== values.type?.id) {
                                                    findLocations(value, (newAllLocations) => {
                                                        setFieldValue(
                                                            'allLocationsForm',
                                                            newAllLocations
                                                        );
                                                    });
                                                }
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <ClinicAutocomplete
                                        width="100%"
                                        optionsDirection="ltr"
                                        loading={locationsSpinner}
                                        disabledInfo={values.type}
                                        options={values.allLocationsForm}
                                        optionsLabel="name"
                                        label={messages.location}
                                        name="locations"
                                        data-testid="location"
                                        value={values.locations}
                                        setValue={(value) => {
                                            setFieldValue('locations', value, true);
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <ClinicInput
                                        width="100%"
                                        touched={touched.requester}
                                        optionalToUse
                                        name="requester"
                                        data-testid="requester"
                                        label={messages.requester}
                                        type="text"
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <ClinicInput
                                        width="100%"
                                        touched={touched.provider}
                                        optionalToUse
                                        name="provider"
                                        data-testid="provider"
                                        label={messages.hospital}
                                        type="text"
                                    />
                                </Grid>
                                {/* <Grid
                                container
                                spacing={2}
                                direction="row"
                                alignItems={'center'}

                            > */}
                                <Grid item xs={6} md={3}>
                                    <CalendarInput
                                        width="100%"
                                        label={messages.date}
                                        data-testid="reported"
                                        name="reported"
                                        value={values.reported}
                                        usePortal
                                        setValue={(value) => {
                                            setFieldValue('reported', value);
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={6} md={3}>
                                    <TimeSelect
                                        width="100%"
                                        optionalToUse
                                        value={values.time}
                                        setTime={(time) => setFieldValue('time', time)}
                                        data-testid="time"
                                        errors={errors.admittedTime && touched.admitted}
                                        label={messages.hour}
                                    />
                                    {/* </Grid> */}
                                </Grid>

                                <Grid className={classes.grid__item__text__editor} item xs={12}>
                                    <div className={classes.TextEditor}>
                                        <TextEditor
                                            isMobile={isMobile}
                                            controllers={
                                                isMobile
                                                    ? [
                                                          'underline',
                                                          'bold',
                                                          'italic',
                                                          'text-right-align',
                                                          'text-center-align',
                                                          'text-left-align'
                                                      ]
                                                    : [
                                                          'bold',
                                                          'italic',
                                                          'underline',
                                                          'strikethrough',
                                                          'text-right-align',
                                                          'text-center-align',
                                                          'text-left-align',
                                                          'highlight',
                                                          'title',
                                                          'numberList',
                                                          'bulletList'
                                                      ]
                                            }
                                            defaultValue={values.content}
                                            handleChange={(value) => {
                                                setFieldValue('content', JSON.stringify(value));
                                            }}
                                            data-testid="content"
                                            inlineToolbarAvailable={false}
                                            label={''}
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid item className={isMobile && mobileClasses.col2}>
                                <Grid item className={classes.grid__item} xs={12}>
                                    <Picture
                                        isAddRadiology={isMobile ? true : false}
                                        showMode={false}
                                        reportId={reportId}
                                        name="images"
                                        data-testid="images"
                                        imagesFiles={imageFiles}
                                        setImageFiles={(files) => {
                                            setFieldValue('images', files);
                                        }}
                                    />
                                </Grid>
                                <Grid className={classes.grid__item__buttons} item xs={12}>
                                    <div className={classes.submitButtons}>
                                        <div>
                                            <Button
                                                fullWidth
                                                type="submit"
                                                variant="contained"
                                                data-testid="submit"
                                            >
                                                {!isSubmitting ? (
                                                    <span>
                                                        {reportId
                                                            ? messages.saveChanges
                                                            : messages.submit}
                                                    </span>
                                                ) : (
                                                    <ButtonCircularProgress />
                                                )}
                                            </Button>
                                        </div>
                                        <div>
                                            <Button
                                                fullWidth
                                                onClick={() => handleCancel(resetForm)}
                                                variant="outlined"
                                            >
                                                {messages.cancel}
                                            </Button>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </Form>
                    </>
                );
            }}
        </Formik>
    );
};
RadiologyForm.propTypes = {
    handleClose: PropTypes.bool,
    onSubmit: PropTypes.func
};

export default WithPatientFileHeader(RadiologyForm, ['sidebar', 'radiology'], true, 'white');
